import { useTranslation } from 'react-i18next';
import type { Hero } from '../../lib/heroes';

type HeroPickerStepProps = {
  heroes: Hero[];
  selectedIds: Set<number>;
  onToggle: (id: number) => void;
  onAddHero: () => void;
  onNext: () => void;
  onBack: () => void;
};

export function HeroPickerStep({
  heroes,
  selectedIds,
  onToggle,
  onAddHero,
  onNext,
  onBack,
}: HeroPickerStepProps) {
  const { t } = useTranslation();
  const hasHeroes = heroes.length > 0;
  const canContinue = selectedIds.size > 0;

  return (
    <div className="wizard-step" data-step="heroes">
      <h2 className="wizard-step__title">{t('wizard.pickHeroesTitle')}</h2>
      <p className="wizard-step__hint">{t('wizard.pickHeroesHint')}</p>

      <div className={`hero-grid${hasHeroes ? '' : ' hero-grid--empty'}`}>
        {heroes.map((hero) => {
          const selected = selectedIds.has(hero.id);
          return (
            <button
              key={hero.id}
              type="button"
              className={`hero-tile${selected ? ' hero-tile--selected' : ''}`}
              onClick={() => onToggle(hero.id)}
              aria-pressed={selected}
              aria-label={t('heroes.selectAria', { name: hero.name })}
            >
              <span className="hero-tile__avatar">
                <img src={hero.photo} alt="" />
              </span>
              <span className="hero-tile__name">{hero.name}</span>
            </button>
          );
        })}

        <button
          type="button"
          className={`hero-tile hero-tile--add${hasHeroes ? '' : ' hero-tile--add--large'}`}
          onClick={onAddHero}
        >
          <span className="hero-tile__avatar hero-tile__avatar--plus" aria-hidden="true">
            +
          </span>
          <span className="hero-tile__name">{t('wizard.addHeroTile')}</span>
        </button>
      </div>

      <div className="wizard-footer">
        <button type="button" className="btn btn--ghost" onClick={onBack}>
          {t('common.cancel')}
        </button>
        <button
          type="button"
          className="btn btn--primary"
          disabled={!canContinue}
          onClick={onNext}
        >
          {t('common.next')}
        </button>
      </div>
    </div>
  );
}
